import { useMutation, useQueryClient } from "react-query";
import apiEndPoints from "services/apiEndPoints";
import makeApiRequest from "services/makeApiRequest";
import { SuccessToast, ErrorToast } from "services/toasterService";

export default function useEditAppliedLeave(closeModal, reset) {
  const queryClient = useQueryClient();
  return useMutation(
    async (data) => {
      const response = await makeApiRequest.put(
        apiEndPoints.EMPLOYEE_LEAVES_API,
        data
      );
      return response?.data;
    },
    {
      onSuccess: (data) => {
        closeModal();
        SuccessToast({ text: data?.message });
        queryClient.invalidateQueries("get-employee-applied-leaves");
        queryClient.invalidateQueries("get-employee-leaves");
        reset({});
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
